import React, { useContext, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { AuthContext } from "./context/AuthContext";
import AppRoutes from "./router/routes";
import Preloader from "./components/Preloader";
import { setupResponseInterceptor } from "./config/axiosConfig";

function App() {
  const { loadingPreloader, handleLogout } = useContext(AuthContext);

  useEffect(() => {
    setupResponseInterceptor(handleLogout);
  }, [handleLogout]);

  if (loadingPreloader) {
    return <Preloader />;
  }

  return (
    <>
      <ToastContainer position="top-right" autoClose={5000} />
      <AppRoutes />
    </>
  );
}

export default App;
